export const CUSTOMER_TYPE_STATUS_ACTIVE = 1
export const CUSTOMER_TYPE_STATUS_INACTIVE = 2

export const CUSTOMER_TYPE_STATUS_NAMES = {
  [CUSTOMER_TYPE_STATUS_ACTIVE]: 'Active',
  [CUSTOMER_TYPE_STATUS_INACTIVE]: 'Inactive',
}

export const CustomerTypeModel = {
  name: '',
  apply_price_on: '',
  status: CUSTOMER_TYPE_STATUS_ACTIVE,
  outlet_ids: [],
}
